( function( $ ) {
	'use strict';

	$( function() {

		// When a variation dropdown changes,
		// change the corresponding URL parameter of the quote/order buttons

		const $buttons = $( '.js-product-quote-order-button' );
		const $variations = $( '.haru-variation-select-box' );

		// Update variation parameters on page load
		$( window ).on( 'load', function() {
			$('.variations select').each( function() {
				// Get select ID and selected option label
				const id = $( this ).attr( 'id' );
				const label = $( this ).find( 'option:selected' ).text();

				updateButtonLinks( id, label );
			} );
		} );

		// Update variation parameters when variations are selected
		$('.variations select').on( 'change', function() {
			// Get select ID and selected option label
			const id = $( this ).attr( 'id' );
			const label = $( this ).find( 'option:selected' ).text();

			updateButtonLinks( id, label );
		} );

		// Set price parameter after variations are selected
		$( '.single_variation_wrap' ).on( 'show_variation', function ( event, variation ) {
			// Change variation display price number to currency format
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
			const price = new Intl.NumberFormat( 'en-AU', { style: 'currency', currency: 'AUD' } ).format( variation.display_price );

			updateButtonLinks( 'product_price', price );
		} );

		const updateButtonLinks = ( param, value ) => {
			$buttons.each( function() {
				// https://usefulangle.com/post/81/javascript-change-url-parameters

				// Get button link and parameters
				const href = $( this ).attr( 'href' );
				const url = new URL( href );
				const searchParams = url.searchParams;

				// Change parameter value
				searchParams.set( param , value );
				url.search = searchParams.toString();

				// The new URL string
				const newUrl = url.toString();

				// Change the button link to the new URL
				$( this ).attr( 'href', newUrl );
			} );
		};
	} );
} )( jQuery );
